import IPlayerData from './IPlayerData';
import { restoreDateString, restoreStringifiedArray } from './ParseHelper';

/**
 * Given an array of endpoint data sets return the data set (if any) with the highest value saved for 'data_timestamp'.
 * @param endPointDataSets
 */
export function getLatestEndpointByDate(endPointDataSets: IPlayerData[]) {
    return endPointDataSets.reduce((acc, val) => {
        if (!val || !val.data_timestamp) return acc;

        const dateString = restoreDateString(val.data_timestamp);
        if (dateString) {
            const timestamp = Date.parse(dateString);
            if (
                !isNaN(timestamp) &&
                (!acc || timestamp >= Date.parse(acc.data_timestamp))
            ) {
                return val;
            }
        }
        return acc;
    }, null);
}

function getLevelDataStars(levelDataString: string): number {
    const levelData: number[] = restoreStringifiedArray(levelDataString);

    if (levelData) {
        return levelData.reduce(
            (total: number, stars: number) => total + Math.max(0, stars),
            0
        );
    }

    return 0;
}

/**
 * Given an array of endpoint data sets return the data set (if any) with the most stars.
 * @param endPointDataSets
 */
export function getEndpointByLevelData(endPointDataSets: IPlayerData[]) {
    return endPointDataSets.reduce((acc, val) => {
        if (!val || !val.stars) return acc;

        const levelStars = getLevelDataStars(val.stars);

        if (
            levelStars !== 0 &&
            (!acc ||
                getLevelDataStars(val.stars) >= getLevelDataStars(acc.stars))
        ) {
            return val;
        }

        return acc;
    }, null);
}

export function getEndpointData(endPointDataSets: IPlayerData[]) {
    if (!Array.isArray(endPointDataSets)) return null;

    return (
        getLatestEndpointByDate(endPointDataSets) ||
        getEndpointByLevelData(endPointDataSets)
    );
}
